import { DEFAULT_VIEW_TYPE } from '@anm/constants/videoLandings';
import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import {
  cleanLandingsStore,
  discardLandingChanges,
  getLandingAsync,
  saveLandingAsync,
  updateLanding,
  updateLandingViewType
} from '../actions';
import { LandingsActions, LandingsState } from '../types';

import getLandingReducer from './getLandingReducer';
import saveLandingReducer from './saveLandingReducer';
import updateLandingReducer from './updateLandingReducer';

export const initialLandingsState: LandingsState = {
  data: null,
  viewType: DEFAULT_VIEW_TYPE,
  getLanding: {
    isError: false,
    isPending: false,
    error: null
  },
  saveLanding: {
    isError: false,
    isPending: false,
    error: null
  }
};

const landingReducer: Reducer<typeof initialLandingsState, LandingsActions> = (
  state = initialLandingsState,
  action
) => {
  switch (action.type) {
    case getType(getLandingAsync.request):
    case getType(getLandingAsync.success):
    case getType(getLandingAsync.failure):
      return getLandingReducer(state, action);

    case getType(saveLandingAsync.request):
    case getType(saveLandingAsync.success):
    case getType(saveLandingAsync.failure):
      return saveLandingReducer(state, action);

    case getType(updateLanding):
    case getType(discardLandingChanges):
    case getType(updateLandingViewType):
      return updateLandingReducer(state, action);

    case getType(cleanLandingsStore):
      return {
        ...initialLandingsState,
        viewType: state.viewType
      };

    default:
      return state;
  }
};

export default landingReducer;
